<template>
  <v-form ref="step1Form"
    v-model="valid"
    lazy-validation>
    <v-row>
      <v-col cols="12">
        <h3 class="text-left">姓名</h3>
        <v-text-field
          v-model="name"
          :rules="nameRules"
          label="請輸入您的姓名"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <h3 class="text-left">請選擇生理性別</h3>
        <v-chip-group
          v-model="gender"
          active-class="blue--text text--accent-3"
          mandatory>
          <v-chip v-for="(genderItem, index) in genderCollections"
          :key="index">
            {{ genderItem }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12">
        <h3 class="text-left">年齡區間</h3>
        <v-chip-group
          class="justify-center"
          v-model="ageRange"
          active-class="blue--text text--accent-3"
          mandatory
          column
        >
          <v-chip v-for="(ageRangeItem, index) in ageRangeCollections"
                  :key="index">
            {{ ageRangeItem }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12">
        <h3 class="text-left">聯絡資料</h3>
        <v-text-field
          v-model="contact"
          label="範例：service@1799.travel"
          hint="請您填入手機、Email 或是任何通訊軟體（請附註帳號 id）"
          :rules="contactRules"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <h3 class="text-left">選擇身份（複選）</h3>
        <v-chip-group
          v-model="professions"
          active-class="blue--text text--accent-3"
          mandatory
          multiple
        >
          <v-chip v-for="(professionItem, index) in professionCollections"
                  :key="index">
            {{ professionItem }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12">
        <h3 class="text-left">以 Freelance 身份帶團多久？（若非 Freelance 請跳過此題）</h3>
        <v-chip-group
          v-model="freelanceExperienceRange"
          active-class="blue--text text--accent-3"
          column>
          <v-chip v-for="(freelanceExperienceRangeItem, index ) in freelanceExperienceRangeCollections"
                  :key="index">{{ freelanceExperienceRangeItem }}</v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12">
        <v-card v-if="professionsHasLeader"
                class="mx-1 mb-2">
          <v-card-title>領隊（可複選）</v-card-title>
          <v-card-text>
            <h4 class="text-left">擅長帶線區域</h4>
            <v-chip-group v-model="leader.expertise"
                          active-class="blue--text text--accent-3"
                          mandatory
                          multiple
                          column>
              <v-chip v-for="(expertiseItem, index ) in leader.expertiseCollections"
                      :key="index">{{ expertiseItem }}</v-chip>
            </v-chip-group>
            <v-combobox class="pt-2"
                        v-model="leader.otherExpertise"
                        chips
                        label="其他"
                        append-icon=""
                        multiple>
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  active-class="blue--text text--accent-3"
                  close
                  @click="select"
                  @click:close="removeLeaderExpertise(item)"
                >
                  <strong>{{ item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <h4 class="text-left">工作經歷</h4>
            <v-chip-group
              v-model="leader.workExperience"
              active-class="blue--text text--accent-3"
              column
              mandatory
            >
              <v-chip v-for="(workExperienceRangeItem, index) in workExperienceRangeCollections"
                      :key="index">
                {{ workExperienceRangeItem }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>
        <v-card v-if="professionsHasTourGuide"
                class="mx-1 mb-2">
          <v-card-title>導遊（可複選）</v-card-title>
          <v-card-text>
            <h4 class="text-left">擅長帶線區域</h4>
            <v-chip-group v-model="tourGuide.expertise"
                          active-class="blue--text text--accent-3"
                          mandatory
                          multiple
                          column>
              <v-chip v-for="(expertiseItem, index ) in tourGuide.expertiseCollections"
                      :key="index">{{ expertiseItem }}</v-chip>
            </v-chip-group>
            <v-combobox class="pt-2"
                        v-model="tourGuide.otherExpertise"
                        chips
                        label="其他"
                        append-icon=""
                        multiple>
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  active-class="blue--text text--accent-3"
                  close
                  @click="select"
                  @click:close="removeTourGuideExpertise(item)"
                >
                  <strong>{{ item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <h4 class="text-left">工作經歷</h4>
            <v-chip-group v-model="tourGuide.workExperience"
                          active-class="blue--text text--accent-3"
                          column
                          mandatory>
              <v-chip v-for="(workExperienceRangeItem, index) in workExperienceRangeCollections"
                      :key="index">
                {{ workExperienceRangeItem }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>
        <v-card v-if="professionsHasTravelAgency"
                class="mx-1 mb-2">
          <v-card-title>旅行社（可複選）</v-card-title>
          <v-card-text>
            <h4 class="text-left">擔任旅行社職位</h4>
            <v-chip-group v-model="travelAgency.expertise"
                          active-class="blue--text text--accent-3"
                          mandatory
                          multiple
                          column>
              <v-chip v-for="(expertiseItem, index ) in travelAgency.expertiseCollections"
                      :key="index">{{ expertiseItem }}</v-chip>
            </v-chip-group>
            <v-combobox class="pt-2"
                        v-model="travelAgency.otherExpertise"
                        chips
                        label="其他"
                        append-icon=""
                        multiple>
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  active-class="blue--text text--accent-3"
                  close
                  @click="select"
                  @click:close="removeTravelAgencyExpertise(item)"
                >
                  <strong>{{ item }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-combobox>
            <h4 class="text-left">旅遊業相關總工作資歷</h4>
            <v-chip-group
              v-model="travelAgency.workExperience"
              active-class="blue--text text--accent-3"
              column
              mandatory
            >
              <v-chip v-for="(workExperienceRangeItem, index) in workExperienceRangeCollections"
                      :key="index">
                {{ workExperienceRangeItem }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-btn
      color="primary"
      @click="submit"
    >
      下一步
    </v-btn>
  </v-form>
</template>

<script>
import { db } from '../plugins/db'

const fStore = db.firestore()

export default {
  name: 'Step1',
  props: {
    userId: String
  },
  data () {
    return {
      step: 1,
      valid: true,
      name: '',
      contact: '',
      gender: 2,
      genderCollections: [
        '男',
        '女',
        '其他'
      ],
      ageRange: 0,
      ageRangeCollections: [
        '21 ~ 25 歲',
        '26 ~ 30 歲',
        '31 ~ 35 歲',
        '36 ~ 40 歲',
        '41 ~ 45 歲',
        '46 ~ 50 歲',
        '51 ~ 55 歲',
        '56 ~ 60 歲',
        '60 歲以上'
      ],
      professions: [0],
      professionCollections: [
        '領隊',
        '導遊',
        '旅行社'
      ],
      freelanceExperienceRange: null,
      freelanceExperienceRangeCollections: [
        '1 年以下',
        '1 ~ 3 年',
        '3 ~ 5 年',
        '5 ~ 10 年',
        '10 年以上'
      ],
      leader: {
        expertise: [],
        otherExpertise: [],
        expertiseCollections: [
          '東北亞',
          '大陸港澳',
          '東南亞',
          '歐洲',
          '美洲',
          '亞非',
          '大洋洲'
        ],
        workExperience: 0,
        rules: [
          v => !!v.length > 0 || '請至少選擇一個'
        ]
      },
      tourGuide: {
        expertise: [],
        otherExpertise: [],
        expertiseCollections: [
          '市區',
          '國家公園',
          '博物館',
          '登山',
          '環島',
          '離島'
        ],
        workExperience: 0,
        rules: [
          v => !!v.length > 0 || '請至少選擇一個'
        ]
      },
      travelAgency: {
        expertise: [],
        otherExpertise: [],
        expertiseCollections: [
          'OP',
          '票務人員',
          '同業業務',
          '直客業務',
          '團控',
          '線控'
        ],
        workExperience: 0,
        rules: [
          v => !!v.length > 0 || '請至少選擇一個'
        ]
      },
      workExperienceRangeCollections: [
        '1 年以下',
        '1~3 年',
        '3~5 年',
        '5~10 年',
        '11~15 年',
        '16~20 年',
        '20 年以上'
      ],
      nameRules: [
        v => !!v || '請填寫姓名'
      ],
      contactRules: [
        v => !!v || '請填寫聯絡資訊'
      ],
      select: null
    }
  },

  computed: {
    professionsHasLeader () {
      return this.professions.includes(0)
    },
    professionsHasTourGuide () {
      return this.professions.includes(1)
    },
    professionsHasTravelAgency () {
      return this.professions.includes(2)
    }
  },

  methods: {
    submit () {
      if (this.$refs.step1Form.validate()) {
        const formData = {
          name: this.name,
          gender: this.genderCollections[this.gender],
          ageRange: this.ageRangeCollections[this.ageRange],
          professions: Object.assign({}, this.professions.map((profession) => {
            return this.professionCollections[profession]
          })),
          selectServices: null,
          aboutClasses: null,
          preferPricing: null,
          createdAt: new Date(),
          endedAt: null
        }

        if (this.freelanceExperienceRange) {
          formData.freelanceExperienceRange = this.freelanceExperienceRangeCollections[this.freelanceExperienceRange]
        }

        if (this.professionsHasLeader) {
          const leaderExpertise = this.leader.expertise.map((item) => {
            return this.leader.expertiseCollections[item]
          })
          const expertise = leaderExpertise.concat(this.leader.otherExpertise)
          formData.leader = {
            expertise: Object.assign({}, expertise),
            workExperience: this.workExperienceRangeCollections[this.leader.workExperience]
          }
        }

        if (this.professionsHasTourGuide) {
          const tourGuideExpertise = this.tourGuide.expertise.map((item) => {
            return this.tourGuide.expertiseCollections[item]
          })
          const expertise = tourGuideExpertise.concat(this.tourGuide.otherExpertise)
          formData.tourGuide = {
            expertise: Object.assign({}, expertise),
            workExperience: this.workExperienceRangeCollections[this.tourGuide.workExperience]
          }
        }

        if (this.professionsHasTravelAgency) {
          const travelAgencyExpertise = this.travelAgency.expertise.map((item) => {
            return this.travelAgency.expertiseCollections[item]
          })
          const expertise = travelAgencyExpertise.concat(this.travelAgency.otherExpertise)
          formData.travelAgency = {
            expertise: Object.assign({}, expertise),
            workExperience: this.workExperienceRangeCollections[this.travelAgency.workExperience]
          }
        }

        fStore.collection('form-1').doc(this.userId).set(formData).then(() => {
          this.$emit('goToStep', this.step + 1)
        })
      }
    },
    removeLeaderExpertise (item) {
      this.leader.otherExpertise.splice(this.leader.otherExpertise.indexOf(item), 1)
      this.leader.otherExpertise = [...this.leader.otherExpertise]
    },
    removeTourGuideExpertise (item) {
      this.tourGuide.otherExpertise.splice(this.tourGuide.otherExpertise.indexOf(item), 1)
      this.tourGuide.otherExpertise = [...this.tourGuide.otherExpertise]
    },
    removeTravelAgencyExpertise (item) {
      this.travelAgency.otherExpertise.splice(this.travelAgency.otherExpertise.indexOf(item), 1)
      this.travelAgency.otherExpertise = [...this.travelAgency.otherExpertise]
    }
  }
}
</script>
